import { ComponentBase, component } from "@sygnal/sse-core";
import { gsap } from "gsap";

@component('problem_pill')
export class ProblemPillComponent extends ComponentBase {

  protected async onLoad(): Promise<void> {
    this.element.addEventListener("click", this.handleClick.bind(this));
  }

  private handleClick(): void {
    const isActive = this.element.classList.contains("problem_active");

    if (isActive) {
      this.element.classList.remove("problem_active");
      gsap.to(this.element, { backgroundColor: "", color: "", duration: 0.3 });
    } else {
      this.element.classList.add("problem_active");
      gsap.to(this.element, { backgroundColor: "#272719", color: "#ffffff", duration: 0.3 });
    }
  }
}
